function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Parser, ProcessNodeDefinitions } from 'html-to-react';
import StaticDemo from '../StaticDemo/StaticDemo';
import LiveDemoHarness from '../LiveDemoHarness/LiveDemoHarness'; // The dynamic JSX tags valid for use in markdown.

import * as MdJsx from '../../md_components';
var htmlToReactParser = new Parser();

function parseAttribs(attribs) {
  var newAttribs = {};
  Object.keys(attribs).reduce(function (attrs, attr) {
    var value = attribs[attr];

    try {
      attrs[attr] = JSON.parse(value);
    } catch (e) {
      attrs[attr] = value;
    }

    return attrs;
  }, newAttribs);
  return newAttribs;
} // Configuration for htmlToReactParser to process jsxtag nodes and dynamically
// create the correct React component.


var processingInstructions = [{
  shouldProcessNode: function shouldProcessNode(node) {
    return node.name === 'jsxtag' && node.attribs && MdJsx[node.attribs.tagname];
  },
  processNode: function processNode(node, children) {
    var attribs = parseAttribs(node.attribs);

    var tagname = attribs.tagname,
        rest = _objectWithoutProperties(attribs, ["tagname"]);

    return React.createElement(MdJsx[tagname], rest, children);
  }
}, {
  // Pass through for all other nodes.
  shouldProcessNode: function shouldProcessNode() {
    return true;
  },
  processNode: new ProcessNodeDefinitions().processDefaultNode
}];

var isValidNode = function isValidNode() {
  return true;
};

var SectionContent = /*#__PURE__*/function (_Component) {
  _inheritsLoose(SectionContent, _Component);

  function SectionContent() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = SectionContent.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        componentName = _this$props.componentName,
        demos = _this$props.demos,
        multiDemos = _this$props.multiDemos,
        local = _this$props.local,
        name = _this$props.name,
        owner = _this$props.owner,
        repoName = _this$props.repoName,
        sections = _this$props.sections,
        theme = _this$props.theme,
        useIframe = _this$props.useIframe;
    return /*#__PURE__*/React.createElement("div", null, sections && sections.map(function (entity, i) {
      if (entity.type === 'livedemo') {
        var demoNum = parseInt(entity.content, 10);

        if (isNaN(demoNum)) {
          return /*#__PURE__*/React.createElement("div", {
            key: "harness-" + i
          }, "Failed parsing live demo for " + entity.content);
        }

        var demo;

        if (demos && demos.length > demoNum) {
          demo = demos[demoNum];
        }

        var demoSize;

        if (entity.demoViews) {
          demoSize = entity.demoViews.defaultView;
        }

        return /*#__PURE__*/React.createElement(LiveDemoHarness, {
          componentName: componentName,
          demo: demo,
          demoIndex: demoNum,
          hideChrome: entity.hideChrome,
          local: local,
          key: "harness-" + i,
          liveDemoKey: i + 1,
          minHeight: entity.minHeight,
          name: name,
          owner: owner,
          repoName: repoName,
          theme: theme,
          useIframe: useIframe,
          demoViews: entity.demoViews,
          demoSize: demoSize,
          hideCodeButton: entity.hideCodeButton
        });
      }

      if (entity.type === 'staticdemo') {
        return /*#__PURE__*/React.createElement(StaticDemo, {
          demoOnly: entity.demoOnly,
          content: entity.content,
          contentHighlighted: entity.contentHighlighted,
          htmlOnly: entity.htmlOnly,
          key: "staticdemo-" + i
        });
      }

      if (entity.type === 'multidemo') {
        var multiDemoSize;
        var isMultiDemo = Array.isArray(multiDemos) && multiDemos.length > 0;

        if (isMultiDemo && multiDemos[0].demo.demoViews) {
          multiDemoSize = multiDemos[0].demo.demoViews.defaultView;
        }

        return /*#__PURE__*/React.createElement(LiveDemoHarness, {
          componentName: componentName,
          demo: multiDemos[0].demo,
          demoSize: multiDemoSize,
          demoViews: multiDemos[0].demo.demoViews,
          isMultiDemo: true,
          key: "multidemo-" + i,
          liveDemoKey: i + 1,
          local: local,
          multiDemos: multiDemos,
          multiDemoKeys: entity.demos,
          name: name,
          owner: owner,
          repoName: repoName,
          theme: theme,
          useIframe: useIframe
        });
      }

      if (entity.type === 'jsx') {
        return htmlToReactParser.parseWithInstructions(entity.content, isValidNode, processingInstructions);
      }

      if (entity.type === 'html' && i > 0) {
        return /*#__PURE__*/React.createElement("div", {
          key: "content" + i,
          dangerouslySetInnerHTML: {
            __html: entity.content
          }
        });
      }

      return '';
    }));
  };

  return SectionContent;
}(Component);

SectionContent.propTypes = {
  componentName: PropTypes.string,
  demos: PropTypes.arrayOf(PropTypes.shape({
    clearStyle: PropTypes.bool,
    content: PropTypes.string,
    noInline: PropTypes.bool
  })),
  multiDemos: PropTypes.arrayOf(PropTypes.shape({
    demo: PropTypes.shape({
      clearStyle: PropTypes.bool,
      content: PropTypes.string,
      noInline: PropTypes.bool,
      minHeight: PropTypes.string,
      demoViews: PropTypes.shape({
        defaultView: PropTypes.oneOf(['xs', 'lg']),
        lg: PropTypes.bool,
        xs: PropTypes.bool
      })
    }),
    description: PropTypes.string,
    label: PropTypes.html
  })),
  local: PropTypes.bool,
  name: PropTypes.string,
  owner: PropTypes.string.isRequired,
  repoName: PropTypes.string,
  sections: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.shape({
    // HTML
    content: PropTypes.string,
    type: PropTypes.string
  }), PropTypes.shape({
    // LiveDemo
    content: PropTypes.string,
    type: PropTypes.string,
    demoViews: PropTypes.shape({
      defaultView: PropTypes.oneOf(['xs', 'lg']),
      lg: PropTypes.bool,
      xs: PropTypes.bool
    }),
    hideChrome: PropTypes.bool,
    hideCodeButton: PropTypes.bool,
    minHeight: PropTypes.string
  }), PropTypes.shape({
    // MultiDemo
    content: PropTypes.string,
    type: PropTypes.string,
    demos: PropTypes.arrayOf(PropTypes.string)
  }), PropTypes.shape({
    // StaticDemo
    content: PropTypes.string,
    type: PropTypes.string,
    contentHighlighted: PropTypes.string,
    demoOnly: PropTypes.bool,
    htmlOnly: PropTypes.bool
  })])),
  theme: PropTypes.string,
  useIframe: PropTypes.bool
};
SectionContent.defaultProps = {
  theme: 'gt'
};
export default SectionContent;
//# sourceMappingURL=SectionContent.js.map